import { AnyAction } from "redux";
import { FindById, Update } from "../../../events";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { EventsAdapter } from "../../../../adapter/events-adapter";

export const FETCH_UPDATE_EVENT_REQUEST = "FETCH_UPDATE_EVENT_REQUEST";
export const FETCH_UPDATE_EVENT_SUCCESS = "FETCH_UPDATE_EVENT_SUCCESS";
export const FETCH_UPDATE_EVENT_FAILURE = "FETCH_UPDATE_EVENT_FAILURE";
export const SET_UPDATE_EVENT = "SET_UPDATE_EVENT";
export const SET_UPDATE_EVENT_DETAILED = "SET_UPDATE_EVENT_DETAILED";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchUpdateEventRequest = () => {
  return {
    type: FETCH_UPDATE_EVENT_REQUEST,
  };
};

const fetchUpdateEventSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_UPDATE_EVENT_SUCCESS,
    payload: data,
  };
};

const fetchUpdateEventFailure = (error: any) => {
  return {
    type: FETCH_UPDATE_EVENT_FAILURE,
    payload: error,
  };
};

export const setUpdateEvent = (data: any) => {
  return {
    type: SET_UPDATE_EVENT,
    payload: data,
  };
};

export const setUpdateEventDetailed = (data: any) => {
  return {
    type: SET_UPDATE_EVENT_DETAILED,
    payload: data,
  };
};

export const update = (id: string, data: any) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateEventRequest());
    try {
      const response = await Update(id, data);
      dispatch(
        fetchUpdateEventSuccess(
          Adapter.from(response.data).to((value) =>
            new EventsAdapter(value).adapt()
          )
        )
      );
    } catch (error: any) {
      dispatch(fetchUpdateEventFailure(error.message));
    }
  };
};

export const findById = (id: string) => {
  console.log("findById", id);
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUpdateEventRequest());
    console.log("dispatching");
    try {
      const response = await FindById(id, "fields=*.*");
      console.log("response", response);
      dispatch(setUpdateEvent(response.data));
      dispatch(
        setUpdateEventDetailed(new EventsAdapter(response.data).adapt())
      );
    } catch (error: any) {
      console.log("error", error);
      dispatch(fetchUpdateEventFailure(error.message));
    }
  };
};
